const gutenbergBlocks = [
	"gutenberg-sample",
	"gutenberg-slider",
	"tedee-background-with-button",
	"tedee-cards",
	"tedee-columns-with-image",
	"tedee-hero",
	"tedee-logo-slider",
	"tedee-media-bar",
	"tedee-posts",
	"tedee-products-compare",
	"tedee-section",
	"tedee-text-with-image-and-icons",
	"tedee-trustpilot",
	"tedee-video-popup",
	"tedee-image-with-html",
]

async function initBlock(className) {

    const blocks = document.getElementsByClassName(`${className}-block`);
    const elementExist = blocks.length > 0;

    if(elementExist){
        await import(`./${className}/style.scss`);
        await import(`./${className}/script.js`)
    }

    return blocks;

}

for (const item of gutenbergBlocks) {
    initBlock(item).then((blocks) => {})
}
